import {get} from 'lodash'
import {
  SIGN_IN,
  SIGN_OUT,
  SET_ACCOUNT_STATE,
} from '../action-types'

const initialState = {
  userid  : '',
  token  : '',
  'token-expiry' : null,
}

export default function AXGAccount(state=initialState, action) {
  switch (action.type) {
    case SET_ACCOUNT_STATE:
      state[action.options.key] = action.options.value
      return assign({}, state)

    case SIGN_IN:

      // TODO: handle side effects properly
      localStorage.setItem('Appxigon.userid', action.options.userid)
      localStorage.setItem('Appxigon.token', action.options.token)
      localStorage.setItem('Appxigon.token-expiry', get(action.options, 'token-expiry'))
      localStorage.setItem('Appxigon.user-error', get(action.options, 'error'))
      console.info(`... registered login token ...`)

      return {
        ...state,
        error: action.options.error,
        'error-description': get(action.options, 'error-description'),
        userid: action.options.userid,
        token: action.options.token,
        'token-expiry': get(action.options, 'token-expiry'),
      }
    case SIGN_OUT:
      // TODO: handle side effects properly
      localStorage.removeItem('Appxigon.userid')
      localStorage.removeItem('Appxigon.token')
      localStorage.removeItem('Appxigon.token-expiry')
      localStorage.removeItem('Appxigon.user-error')

      return {
        ...state,
        error: '',
        'error-description': '',
        userid  : '',
        token: '',
        'token-expiry': null,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./redux/reducers/axg-account.js